module.exports = __webpack_public_path__ + "static/media/vf_mcoat_core.708614b1.svg";